import { Flex, Text } from '@backstage/ui';
import Icon from '@mdi/react';
import { mdiCheckBold, mdiCloseThick, mdiEmailFast } from '@mdi/js';
import { EventData, UserStatus } from '../../types/EventData';
import { InviteButton } from './InviteButton';

interface InviteStatusProps {
  eventData: EventData;
  isPrimary?: boolean;
}

export const InviteStatus = ({ eventData, isPrimary = true }: InviteStatusProps) => {
  const userStatus = eventData.userStatus;

  if (userStatus.isNotInvited) {
    return (
      <InviteButton
        eventId={eventData.eventId}
        eventSeriesId={eventData.eventSeriesId}
        isPrimaryButton={isPrimary}
        disabled={eventData.isInThePast}
      />
    );
  }

  const { icon, colorToken } = getInviteStatusDisplay(userStatus);
  return (
    <Flex align="center" gap="1" justify="center">
      <Icon path={icon} size="1.2em" color={`var(--bui-fg-${colorToken})`} />
      <Text color={colorToken} variant="body-medium" as="p">
        {userStatus.statusText}
      </Text>
    </Flex>
  );
};

function getInviteStatusDisplay(userStatus: UserStatus): {
  icon: string;
  colorToken: 'success' | 'danger' | 'primary';
} {
  if (userStatus.hasAccepted) {
    return { icon: mdiCheckBold, colorToken: 'success' };
  }
  if (userStatus.hasDeclined) {
    return { icon: mdiCloseThick, colorToken: 'danger' };
  }
  return { icon: mdiEmailFast, colorToken: 'primary' };
}
